import React from "react"

const LivescoringFilterTeeButton = ({
    teeId,
    teeName,
    teeAlias,
    categoryId,
    categoryName,
    filterTees,
    updateFilters
}) => {

    return (
        <div className={`livescoring-filter-tee-item livescoring-filter-button ${filterTees.includes(categoryId) && "livescoring-filter-button-active"}`} onClick={() => updateFilters("tees", categoryId)}>
            <div className="livescoring-filter-tee-item-color-zone">
                <div className={`livescoring-filter-tee-item-color ${teeId}Tee`}>
                    { teeAlias ? teeAlias : '' }
                </div>
            </div>
            <div className="livescoring-filter-tee-text-zone">
                <label className="livescoring-filter-tee-name">{ categoryName }</label>
                <label className="livescoring-filter-tee-category">{ teeName }</label>
            </div>
        </div>
    )
}

export default LivescoringFilterTeeButton
